module.exports = __webpack_public_path__ + "static/6-9e63caa4c352587bb8d17e71452d9085.jpg";